import React, { useEffect, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './PinPopToDStore.module.less';
import { PCStoreJsBridge } from '../../nativeapi';
import { logging } from '../../actions/log';

import { CLEAN_STORE_TO_DSTORE_83 } from '../../config';
import { cacheKeys } from '../../constants/storageKeys';
import { createAxios, logNative, localGetItem, localSetItem } from '../../utils/utils';
import { setCleanToDStoreVisible } from '../../actions/layout';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  // 发送请求触发集成包洗包到独立包
  const postCleanStoreToDStore = useCallback(async () => {
    try {
      const axios = await createAxios();
      const res = await axios.post(CLEAN_STORE_TO_DSTORE_83, { hasConfirm: 1 });
      if (res.data.status === 0) {
        logNative(`发送请求触发集成包洗包到独立包，请求结果成功`, res.data);
        PCStoreJsBridge.closeWindow();
      } else {
        logNative(`发送请求触发集成包洗包到独立包，请求结果失败`, res.data);
        PCStoreJsBridge.closeWindow();
      }
    } catch (err) {
      logNative(`发送请求触发集成包洗包到独立包，请求失败`, err);
      PCStoreJsBridge.closeWindow();
    }
  }, []);

  // 点击确定
  const handleSure = useCallback(() => {
    // 快捷方式弹窗 直接退出
    dispatch(
      logging({
        category: 'C',
        action: 'Store_To_DStore_Sure',
        label: '',
        param2: {
          source: 'Store_To_DStore',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    localSetItem(cacheKeys.SHOW_CLEAN_TO_DSTORE_TIME, +new Date());
    dispatch(setCleanToDStoreVisible(false));
    postCleanStoreToDStore();
  }, [dispatch]);

  // 点击取消或者关闭
  const handleClose = useCallback(
    flag => {
      // 快捷方式弹窗 暂不退出 关闭弹窗
      dispatch(
        logging({
          category: 'C',
          action: flag ? 'Store_To_DStore_X' : 'Store_To_DStore_Cancle',
          label: '',
          param2: {
            source: 'Store_To_DStore',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      localSetItem(cacheKeys.SHOW_CLEAN_TO_DSTORE_TIME, +new Date());
      dispatch(setCleanToDStoreVisible(false));
      PCStoreJsBridge.closeWindow();
    },
    [dispatch],
  );

  useEffect(() => {
    // 快捷方式弹窗 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Store_To_DStore',
        label: '',
        param2: {
          source: 'Store_To_DStore',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.pinpop}>
      <div className="header">
        <span className="title">新版本更新提醒</span>
        <span className="close iconfont icon-close" onClick={() => handleClose(true)} />
      </div>
      <div className="message">
        已为你准备好应用商店的新版本，主要更新如下：
        <br />
        1. 更快的应用下载速度；
        <br />
        2. 更强大的应用管理能力；
        <br />
        3. 应用商店独立升级与卸载；
      </div>
      <div className="message_">是否要在商店关闭后开始后台更新？</div>
      <div className="btn-wrapper">
        <span className="btn_default" onClick={() => handleClose()}>
          取消
        </span>
        <span className="btn_primary" onClick={() => handleSure()}>
          确认
        </span>
      </div>
    </div>
  );
});
